class SizeChart extends HTMLElement {
  constructor() {
    super();

    this.chart = this.getAttribute("data-chart");
    this.countryMenu = document.querySelector(
      `.size_chart-${this.chart} .country_options`
    );
    this.expandBtn = document.querySelector(
      `.size_chart-${this.chart} .expand_btn_row`
    );
    this.expandable_tr = document.querySelectorAll(
      `.size_chart-${this.chart} .expandable_tr`
    );

    this.init();
  }

  init() {
    const countryMenu = this.countryMenu;
    const expandBtn = this.expandBtn;
    const expandable_tr = this.expandable_tr;

    if (countryMenu) {
      countryMenu.addEventListener("change", (event) => {
        const selectedValue = event.target.value;
        for (let i = 0; i < countryMenu.length; i++) {
          const option = countryMenu.options[i].value;
          const tdClass = ".size-" + option;
          const tdOptions = document.querySelectorAll(tdClass);
          if (option != selectedValue) {
            tdOptions.forEach((op) => {
              op.style.display = "none";
            });
          } else if (option == selectedValue) {
            tdOptions.forEach((op) => {
              op.style.display = "table-cell";
            });
          }
        }
      });
    }

    if (expandBtn) {
      expandBtn.addEventListener("click", () => {
        if (expandBtn.children[0].innerHTML == "Collapse") {
          expandable_tr.forEach((tr) => {
            tr.style.display = "none";
            expandBtn.children[0].innerHTML = "Expand FOR MORE SIZES";
          });
        } else {
          expandable_tr.forEach((tr) => {
            tr.style.display = "table-row";
            expandBtn.children[0].innerHTML = "Collapse";
          });
        }
      });
    }
  }
}
customElements.define("size-chart", SizeChart);
